import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { useSessionRecorder } from 'src/hooks/use-session-recorder';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { getMenuWidget } from 'src/services/cmsApi';
import { openMyAccountModal } from 'src/store/account-modal/actions';
import { setDeepLink } from 'src/store/app/actions';
import { CmsMenuWidgetItem } from 'src/types/cms/cmsWidgetTypes';
import { RootState } from 'src/types/store-types';
import './styles.scss';

type Props = {
  placement: string;
};
const ReferAFriendWidget: FC<Props> = ({ placement }) => {
  const sessionRecorder = useSessionRecorder();
  const { locale } = useI18n();
  const { refFriendAction } = useBannerActions();

  const [rafMenuItem, setRafMenuItem] = useState<CmsMenuWidgetItem | null>(null);

  const _openAccountModal = useConnectedAction(openMyAccountModal);
  const _setDeepLink = useConnectedAction(setDeepLink);

  const { user } = useSelector((state: RootState) => state.user);
  const { deepLink } = useSelector((state: RootState) => state.app);

  const ctaAction = useCallback((): void => {
    sessionRecorder?.trackEvent('"Invite a friend" button click', {
      placement,
    });
    refFriendAction();
  }, [placement, refFriendAction, sessionRecorder]);

  useEffect(() => {
    if (deepLink === 'raf' && user) {
      setTimeout(() => {
        _openAccountModal({ section: 'referAFriend', subSection: 'referAFriend' });
        _setDeepLink('');
      }, 0);
    }
  }, [deepLink, user]);

  useEffect(() => {
    let isMounted = true;

    getMenuWidget(locale).then((res) => {
      if (!isMounted || !res.success) return;

      const menuItems = res.result?.[0]?.content?.menuItems ?? [];
      const rafItem = menuItems.find((item) => item.category === 'raf') ?? null;
      setRafMenuItem(rafItem);
    });

    return () => {
      isMounted = false;
    };
  }, [locale]);

  if (!rafMenuItem) return null;

  return (
    <div className="refer_a_friend_wrapper">
      <Button
        className="refer_a_friend_wrapper_btn"
        key={rafMenuItem.category}
        type="button"
        onClick={() => ctaAction()}
      >
        <img src={rafMenuItem.imageDesktopOpened?.path ?? ''} alt={rafMenuItem.category} />
      </Button>
    </div>
  );
};
export default ReferAFriendWidget;
